import React from 'react';

const AccountDeactivatedModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
        <div className="px-6 py-8 flex flex-col items-center">
          <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-yellow-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M12 5a7 7 0 100 14 7 7 0 000-14z" />
            </svg>
          </div>
          <h3 className="type-auth-title mb-2">حساب کاربری غیرفعال است</h3>
          <p className="text-gray-700 text-center mb-4">
            حساب کاربری شما توسط تیم پشتیبانی غیرفعال شده است و امکان استفاده از داشبورد وجود ندارد.<br />
            برای فعال‌سازی مجدد، لطفاً با پشتیبانی تماس بگیرید.
          </p>
          <a
            href="/contact"
            className="w-full block text-center px-4 py-3 rounded-lg bg-signal text-white hover:bg-signal-hover font-medium"
          >
            تماس با پشتیبانی
          </a>
        </div>
      </div>
    </div>
  );
};

export default AccountDeactivatedModal;


